import {Image} from "../../../stem-core/src/ui/UIPrimitives.jsx";
import {Dispatcher} from "../../../stem-core/src/base/Dispatcher.js";
import {sanitizeUrlFromOptions} from "./PanelLink.jsx";

export class PanelImage extends Image {
    setOptions(options) {
        return super.setOptions(sanitizeUrlFromOptions(options, "src"));
    }

    onMount() {
        this.addLoadListener(() => Dispatcher.Global.dispatch("iframeSizeChange"));
    }
}